import DatePicker from "react-multi-date-picker";
import "react-multi-date-picker/styles/layouts/mobile.css";
import opacity from "react-element-popper/animations/opacity";
import dayjs from "dayjs";
import { KTIcon } from '../../../../_metronic/helpers'

const GiftVoucherHeader = ({
  setOpenCreateVoucherModal,
  currentUser,
  haveAccess,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  displayType,
  setDisplayType
}) => {
  return (
    <>
      <div className='card-header border-0 pt-6 justify-space-between align-items-center'>
        <div className='d-flex column-gap-3'>
          <>
            <div className="position-relative">
              <DatePicker
                inputClass='datepicker-input'
                containerStyle={{
                  width: "100%"
                }}
                className="rmdp-mobile custom-calendar"
                arrow={false}
                value={startDate}
                onChange={(val) => {
                  setStartDate(val);
                }}
                maxDate={dayjs(endDate).toDate()}
                format="dddd MMM DD,YYYY"
                fixMainPosition={true}
                animations={[opacity()]}
                placeholder="Filter by Start Date"
                weekDays={["S", "M", "T", "W", "T", "F", "S"]}
                scrollSensitive={false}
                hideOnScroll={false}
                mobileButtons={[
                  {
                    label: "RESET",
                    type: "button",
                    className: "rmdp-button rmdp-action-button",
                    onClick: () => setStartDate(null),
                  },
                ]}
              />
            {startDate && <ResetButton onClick={() => setStartDate(null)} />}
            </div>
            <div className="position-relative">
              <DatePicker
                inputClass="datepicker-input"
                containerStyle={{
                  width: "100%"
                }}
                className="rmdp-mobile custom-calendar"
                arrow={false}
                value={endDate}
                onChange={(val) => {
                  setEndDate(val);
                }}
                minDate={dayjs(startDate).toDate()}
                format="dddd MMM DD,YYYY"
                fixMainPosition={true}
                animations={[opacity()]}
                placeholder="Filter by End Date"
                weekDays={["S", "M", "T", "W", "T", "F", "S"]}
                scrollSensitive={false}
                hideOnScroll={false}
                mobileButtons={[
                  {
                    label: "RESET",
                    type: "button",
                    className: "rmdp-button rmdp-action-button",
                    onClick: () => setStartDate(null),
                  },
                ]}
              />
            {endDate && <ResetButton onClick={() => setEndDate(null)} />}
            </div>
          </>
        </div>
        <div className='card-toolbar' style={{ gap: '5px' }}>
          {(haveAccess(currentUser, 'redemption_codes_create')) &&
            <button type='button' className='btn' style={{ backgroundColor: "#2ecc71", color: "white" }}
              onClick={() => {
                setOpenCreateVoucherModal(true)
              }}
            >
              <KTIcon iconName='plus' className='fs-2 text-white' />
              Create Voucher
            </button>
          }
        </div>
      </div>
      <div className='card-header border-0 pt-0 justify-start align-items-center'>
        <div className="nav-group nav-group-fluid d-inline-block">
          <label>
            <input
              type="radio"
              className="btn-check"
              name="cycle_type"
              checked={displayType === 'list'}
              onChange={() => {
                setDisplayType('list')
              }}
            />
            <span className="btn btn-sm btn-active btn-active-primary fs-6 fw-bold">
              List View
            </span>
          </label>
          <label>
            <input
              type="radio"
              className="btn-check"
              name="cycle_type"
              checked={displayType === 'grid'}
              onChange={() => {
                setDisplayType('grid')
              }}
            />
            <span className="btn btn-sm btn-active btn-active-primary px-4 fs-6 fw-bold">
              Grid View
            </span>
          </label>
        </div>
      </div>
    </>
  )
}

export { GiftVoucherHeader }

const ResetButton = ({ onClick = () => {} }) => {
  return <button
    onClick={onClick}
    className="datepicker-clear"
  >
  <KTIcon iconName='cross' className='fs-1 text-danger fw-bold' />
  </button>
}